<template>
  <!-- 立即评价 -->
  <el-dialog
    :title="$t('HistoricalRedemptionRecords.ProductEvaluation')"
    :visible.sync="orderRatedVisible"
    :close-on-click-modal="false"
    width="600px"
    @close="handleOrderRatedModal(false)"
  >
    <el-form
      ref="ratedForm"
      label-width="120px"
      :model="ratedForm"
      :loading="loading"
      size="small"
      class="evaluation-form-dialog"
    >
      <!-- <el-form-item
        label="商品质量"
        :prop="'productQuality'"
        :rules="{
          required: true,
          validator: rateCheck,
          trigger: 'change',
        }"
      >
        <el-rate v-model="ratedForm.productQuality"></el-rate>
      </el-form-item>
      <el-form-item
        label="物流质量"
        :prop="'logisticsService'"
        :rules="{
          required: true,
          validator: rateCheck,
          trigger: 'change',
        }"
      >
        <el-rate v-model="ratedForm.logisticsService"></el-rate>
      </el-form-item> -->
      <el-form-item
        :label="$t('HistoricalRedemptionRecords.QualityOfService')"
        :prop="'evaluationLevel'"
        :rules="{
          required: true,
          validator: rateCheck,
          trigger: 'change'
        }"
      >
        <el-rate v-model="ratedForm.evaluationLevel"></el-rate>
      </el-form-item>
      <el-form-item
        :label="$t('HistoricalRedemptionRecords.EvaluationContent')"
        :prop="'content'"
        :rules="{
          required: true,
          message: $t('InvoiceInquiry.PleaseEnter'),
          trigger: 'blur'
        }"
      >
        <el-input
          type="textarea"
          v-model="ratedForm.content"
          :placeholder="$t('InvoiceInquiry.PleaseEnter')"
          minlength="5"
          maxlength="250"
          show-word-limit
          :clearable="true"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleOrderRatedModal(false)">{{
        $t('ServiceEvaluation.Cancel')
      }}</el-button>
      <el-button type="primary" :loading="loading" @click="orderRated">{{
        $t('ServiceEvaluation.Confirm')
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { submitOrderEvaluation } from '@/api/pointsMall'
import i18n from '@/i18n/i18n'
export default {
  props: {
    // goodsType: {
    //   type: Number,
    //   default: 0
    // },
    // selectedItem: {
    //   type: Object,
    //   default: () => {
    //     return {}
    //   }
    // },
  },
  data() {
    return {
      loading: false,
      orderRatedVisible: false, // 立即评价弹框
      currentOrder: {},
      ratedForm: {
        // logisticsService: 0, // 物流质量
        // productQuality: 0, // 产品质量
        evaluationLevel: 0, // 服务质量
        content: '' // 评价内容
      }
    }
  },
  computed: {
  },
  methods: {
    rateCheck(rule, value, callback) {
      console.log('rule', rule, value)
      if (value == '0') {
        console.log('rule', rule)
        const tipText = rule.field.includes('productQuality') ? i18n.t('HistoricalRedemptionRecords.ProductQuality') : rule.field.includes('evaluationLevel') ? i18n.t('HistoricalRedemptionRecords.ServiceQuality') : i18n.t('HistoricalRedemptionRecords.logisticsQuality')
        callback(new Error(tipText))
      } else {
        callback()
      }
    },
    // 立即评价弹框
    handleOrderRatedModal(status, record) {
      this.orderRatedVisible = status
      console.log('handleOrderRatedModal', status, record)
      if (!status) {
        this.$refs.ratedForm.resetFields()
        this.currentOrder = {}
        this.ratedForm = {
          // logisticsService: 0, // 物流质量
          // productQuality: 0, // 产品质量
          evaluationLevel: 0, // 服务质量
          content: '' // 评价内容
        }
      } else {
        this.currentOrder = record
        this.ratedForm = {
          // logisticsService: 0, // 物流质量
          // productQuality: 0, // 产品质量
          evaluationLevel: 0, // 服务质量
          content: '' // 评价内容
        }
      }
    },
    rateValue(val) {
      console.log('当前分数', val, this.ratedForm)
    },
    // 立即评价
    orderRated() {
      if (this.loading) {
        return
      }
      this.$refs.ratedForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { ID } = this.currentOrder
          const params = {
            orderID: ID,
            // logisticsService: this.ratedForm.logisticsService, // 物流质量
            // productQuality: this.ratedForm.productQuality, // 产品质量
            evaluationLevel: this.ratedForm.evaluationLevel, // 服务质量
            CommodityLanguageType: this.$ls.get('lang') == 'zh' ? 0 : 1,
            content: this.ratedForm.content // 评价内容
          }
          console.log('上传参数', params)
          submitOrderEvaluation(params)
            .then((res) => {
              if (res && res.code == 200) {
                this.$message.success(i18n.t('HistoricalRedemptionRecords.EvaluationSuccessful'))
                this.handleOrderRatedModal(false)
                this.$emit('refreshList')
              } else {
                this.$message.success(i18n.t('HistoricalRedemptionRecords.EvaluationFailed'))
              }
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.evaluation-form-dialog {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner {
    border: 1px solid #dcdfe6 !important;
    background: #ffffff !important;
  }
  .el-form-item__error {
    position: relative;
  }
  .el-form-item.address-select {
    /deep/.el-form-item__content {
      display: flex;
    }
    .el-form-item {
      margin-top: 0;
    }
  }
}
</style>
